import {
    FETCH_WECHATMERCHANTS,
    FETCH_ALIPAYMERCHANTS, FETCH_USER_MERCHANTS
} from '../actions/payConfig';


export const initialState = {
    isFetching: true,
    data: null
};

export const merchantList = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_USER_MERCHANTS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_USER_MERCHANTS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const wechatMerchants = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_WECHATMERCHANTS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_WECHATMERCHANTS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const alipayMerchants = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ALIPAYMERCHANTS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ALIPAYMERCHANTS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/payConfig.js